const fullscreen = function (Vue) {
    Vue.directive('fullscreen', {
        bind: function (el, binding) {
            const headDom = el.querySelector('.el-dialog__header')
            const beforeDom = el.querySelector('.el-dialog__headerbtn')
            //在关闭按钮之前插入全屏按钮
            const button = document.createElement('button')
            button.classList.add('el-dialog__headerbtn', 'full-screen-button')
            button.style.cssText += `right: 40px;`
            const i = document.createElement('i')
            i.style.cssText += `color:#909399;font-size:22px`
            i.classList.add("el-icon-fanhuizhengchangpingmu")
            button.appendChild(i)
            headDom.insertBefore(button, beforeDom)
        },
        inserted: function (el, binding, vnode) {
            // el.style.cssText += 'transition:all .5s'
            const fullButton = el.querySelector('.full-screen-button')
            const fullChildDom = fullButton.childNodes[0]
            const dialogDom = el.querySelector('.el-dialog')
            const dialogMarginTop = dialogDom.style.marginTop
            let minScreenStyle = `width:20%;height:10%;top:88vh;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)`
            let fullScreenStyle = `width:100%;height:100%;top:0;box-shadow: none`
            fullChildDom.addEventListener('mouseover', function (e) {
                this.style.color = '#409EFF'
            })
            fullChildDom.addEventListener('mouseout', function (e) {
                this.style.color = '#909399'
            })
            fullButton.addEventListener('click', function (e) {
                const icon = e.target.classList.value
                if (icon === 'el-icon-fanhuizhengchangpingmu') {
                    el.style.cssText += minScreenStyle
                    dialogDom.style.marginTop = '0vh'
                    fullChildDom.style.fontSize="16px"
                    fullChildDom.classList.remove('el-icon-fanhuizhengchangpingmu')
                    fullChildDom.classList.add('el-icon-full-screen')
                } else {
                    el.style.cssText += fullScreenStyle
                    dialogDom.style.marginTop = dialogMarginTop
                    fullChildDom.style.fontSize="22px"
                    fullChildDom.classList.remove('el-icon-full-screen')
                    fullChildDom.classList.add('el-icon-fanhuizhengchangpingmu')
                }
            })
            // 点击关闭按钮还原设置
            const closeButton = el.querySelector('.el-dialog__close')
            closeButton.addEventListener('click', function (e) {
                el.style.cssText += `display:none;${fullScreenStyle}`
                dialogDom.style.marginTop = dialogMarginTop
                fullChildDom.classList.remove('el-icon-full-screen')
                fullChildDom.classList.add('el-icon-fanhuizhengchangpingmu')
            })
        }
    })
}

export default fullscreen